/* eslint-disable no-undef */
// App.jsx
import React from 'react'
import { Typography, AppBar, Button, Card, CardActions, CardContent, CardMedia, CssBaseline, Grid, Toolbar, Container,  } from '@material-ui/core/'
import { PhotoCamera } from '@material-ui/icons'
import useStyles from './styles'
const cards = [1, 2, 3, 4, 5, 6, 7, 8, 9]
const App = () => {
	const classes = useStyles()
	return (
		<>
			<CssBaseline />
			<AppBar position='relative'>
				<Toolbar>
					<PhotoCamera className={classes.icon} />
					<Typography variant ="h6">
							RamonaPhotograb
					</Typography>
				</Toolbar>
			</AppBar>
			<main>
				<div className={classes.container}>
					<Container maxWidth='sm'>
						<Typography 
							variant='h2' align='center' color='textPrimary' gutterBottom
						>
							Album Layout with React and Material
						</Typography>
						<Typography 
							variant='h5' align='center' color='textSecondary' paragraph
						>
							Refresh page for a random Unsplash.com photo 
						</Typography>						
					</Container>
				</div>


				<Container className={classes.cardGrid} maxWidth='md'>
					<Grid container spacing={2}> 
					{cards.map(() => ( 
								<Grid item key={Card}  xs={12} sm={6} md={4} >
								<Card className={classes.card}>
									<CardMedia 
										className={classes.cardMedia} 
										image='https://source.unsplash.com/random'
										title="Image title"
									/>
									<CardContent className={classes.cardContent}>
										<Typography gutterBottom variant='h3'>
											Heading
										</Typography>
										<Typography>
											This is some description text. Just a paragraph maybe, to describe the photo.
										</Typography>
									</CardContent>
									<CardActions >
										<Button size='small' variant='contained' color='primary'>View</Button>
										<Button size='small' variant='outlined' color='secondary'>Edit</Button>
									</CardActions>
								</Card>
								</Grid>
					))}
					</Grid>
				</Container>
			</main>
			<footer className={classes.footer}>
			<Typography gutterBottom variant='h6' align='center'>
					RamonaPhotograb Footer
			</Typography>		
			<Typography gutterBottom variant='subtitle1' align='center' color='textSecondary'>
					100% Responsive
			</Typography>							
						<div className={classes.button}>
							<Grid container spacing={2} justifyContent='center'>
								<Grid item>
									<Button variant='contained' color='primary'>
										Sample Button
									</Button>
								</Grid>
							</Grid>
						</div>
			</footer>
		</>
	)
}
export default App